import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Quote, QuoteStatus, QuotesState } from "../types";

export const sliceKey = "quotesState";

export const mockQuotes: Quote[] = [
  {
    id: "1",
    quoteNumber: "Q-8091",
    createdAt: "2026-03-10",
    customerNameKey: "QUOTES.MOCK.CUSTOMER.GALON",
    projectTypeKey: "QUOTES.MOCK.PROJECT.MARCH_10",
    revisionNumber: 1,
    totalValue: 66600,
    status: QuoteStatus.DRAFT,
    validUntil: "2026-04-10",
    descriptionKey: "QUOTES.MOCK.DESCRIPTION.Q_8091",
  },
  {
    id: "2",
    quoteNumber: "Q-8092",
    createdAt: "2026-03-10",
    customerNameKey: "QUOTES.MOCK.CUSTOMER.GALON",
    projectTypeKey: "QUOTES.MOCK.PROJECT.HEAVY_TIPPER",
    revisionNumber: 2,
    totalValue: 66600,
    status: QuoteStatus.SENT,
    validUntil: "2026-04-10",
    descriptionKey: "QUOTES.MOCK.DESCRIPTION.Q_8092",
  },
  {
    id: "3",
    quoteNumber: "Q-8094",
    createdAt: "2026-03-10",
    customerNameKey: "QUOTES.MOCK.CUSTOMER.GALON",
    projectTypeKey: "QUOTES.MOCK.PROJECT.CUSTOM_OPEN_BODY",
    revisionNumber: 1,
    totalValue: 66600,
    status: QuoteStatus.ACCEPTED,
    validUntil: "2026-04-10",
    descriptionKey: "QUOTES.MOCK.DESCRIPTION.Q_8094",
  },
];

export const initialState: QuotesState = {
  list: mockQuotes,
  selectedQuote: null,
  loading: false,
  detailLoading: false,
  error: null,
  search: "",
  statusFilter: "ALL",
};

const quotesSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getQuotesList(state) {
      state.loading = state.list.length === 0;
      state.error = null;
    },

    getQuotesListSuccess(state, action: PayloadAction<Quote[]>) {
      state.loading = false;
      state.list = action.payload;
    },

    getQuotesListFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    getQuoteDetails(state, action: PayloadAction<string>) {
      state.detailLoading = false;
      state.error = null;

      const quote = state.list.find((item) => item.id === action.payload);

      if (quote) {
        state.selectedQuote = quote;
      }
    },

    getQuoteDetailsSuccess(state, action: PayloadAction<Quote>) {
      state.detailLoading = false;
      state.selectedQuote = action.payload;
    },

    getQuoteDetailsFailed(state, action: PayloadAction<string>) {
      state.detailLoading = false;
      state.error = action.payload;
    },

    setQuotesSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },

    setQuotesStatusFilter(state, action: PayloadAction<QuoteStatus | "ALL">) {
      state.statusFilter = action.payload;
    },
  },
});

export const { actions: quotesActions, reducer } = quotesSlice;

export const quotesReducer = reducer;